export const TipsBeginners = {
  immediateInvitation: '立即邀请',
  iKnow: '我知道了',
  projectWarning: '项目风险和进度实时预警',
  shortcutFunctionEntry: '快捷功能入口',
  projectDetailTipFirst: '· 项目施工计划一目了然 /r/n· 项目图纸实时查看 /r/n· 项目成员便于管理',
  projectDetailTipSecond: '显示项目全生命周期进展',
  projectDetailTipThird: '实时跟进单个计划的进展',
  projectDetailTipSecondSubTip: '包括未开始、进行中、已延期、待验收、验收通过',
  projectDetailImageTipFirst: '可及时删除项目成员',
  projectDetailImageTipSecond: '点击邀请成员',
  projectDetailImageTipFirstSubTip: '再次保障项目信息安全',
  progressDetailTipFirst: '过程交流内容留底可追溯',
  constantsPageTipFirst: '邀请常用联系人供项目调用',
  constantsPageTipSecond: '保障信息安全',
  constantsPageTipSecondSubTip: '分享仅7天内且对1人有效',
  selectRoleTipFirst: '基于角色添加便于管理',
  selectRoleTipSecond: '保障项目信息安全',
  selectRoleTipSecondSubTip: '分享仅7日内有效',
  constructionFilesTipFirst: '支持发送给指定成员',
  constructionFilesTipSecond: '支持PDF施工图、效果图图片',
  commentListTipFirst: '可多维度筛选查看评论列表',
  commentListTipSecond: '有图片、音视频的评论，区分显示',
  commentListTipFirstSubTip: '按角色、解决状态、当前或全部图纸',
  pdfViewTipFirst: '使用评论功能',
  pdfViewTipSecond: '支持点对点沟通',
  pdfViewTipThird: '实时向全员同步解决结果',
  pdfViewTipFourth: '分类查看项目所有评论',
  pdfViewTipSecondSubTip: '可添加含图片、音视频的评论和回复',
  pdfViewTipThirdSubTip: '包括未解决、已解决和关闭',

};
